import { TrainingSessionContact } from './contact/training-session-contact.model';

export class TrainingSessionCompany {
    constructor(
        public id?: number,
        public version?: number,
        public deleted?: boolean,
        public price?: number,
        public priceCurrency?: string,
        public registrationId?: number,
        public billingMode?: string,
        public name?: string,
        public companyId?: number,
        public contacts?: TrainingSessionContact[],
        public selected?: boolean,
        public editingMode?: string,
        public commercialName?: string,
        public financed?: boolean,
        public financingCompany?: string,
        public orderNumber?: string,
        public salesPerson?: { id: number }
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/_services/session/company/training-session-company.model.ts